import { useState } from "react";
import Modal from "../components/Modal";

const About = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <button onClick={handleOpenModal}>Open Modal</button>
      {isModalOpen && <Modal onClose={handleCloseModal} />}
    </div>
  );
};

export default About;
